import { ChevronLeftIcon, ChevronRightIcon, Search2Icon } from '@chakra-ui/icons'
import { Box, Button, Center, Heading, SimpleGrid, Text } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import React from 'react'

import { Spinner } from '@/components/Spinner'
import { UkiyoePreview } from '@/components/UkiyoePreview'

type Props = {
  ids: number[]
  isLoading: boolean
  page: number
  isLastPage: boolean
  onClickNextPage: () => void
  onClickPrevPage: () => void
}

export const MyCollections = ({
  ids,
  page,
  onClickPrevPage,
  onClickNextPage,
  isLoading,
  isLastPage,
}: Props) => {
  return (
    <>
      <chakra.section mt="8">
        <Heading as="h1" size="lg">
          My Collection
        </Heading>
        {isLoading ? (
          <Box mt="8" textAlign="center">
            <Spinner />
          </Box>
        ) : (
          <>
            {ids.length > 0 ? (
              <>
                <Center mt="4">
                  <SimpleGrid minH={[128 * 4, 128 * 2]} w="full" columns={[2, 4]} p={2} spacing={2}>
                    {ids.map((id) => {
                      return <UkiyoePreview key={id} id={id} href={`/collections/${id}`} />
                    })}
                  </SimpleGrid>
                </Center>
                <Box mt="4" display={{ md: 'flex' }} justifyContent={{ md: 'center' }}>
                  {page > 1 && (
                    <Box>
                      <Button
                        disabled={page === 1}
                        onClick={onClickPrevPage}
                        colorScheme="teal"
                        variant="outline"
                        minW={{ base: 'full', md: '60' }}
                      >
                        <ChevronLeftIcon />
                        <chakra.span ml="1">Prev</chakra.span>
                      </Button>
                    </Box>
                  )}

                  {!isLastPage && (
                    <Box ml={{ base: 0, md: 8 }} mt={{ base: 8, md: 0 }}>
                      <Button
                        onClick={onClickNextPage}
                        colorScheme="teal"
                        variant="outline"
                        minW={{ base: 'full', md: '60' }}
                      >
                        <chakra.span ml="1">Next</chakra.span>
                        <ChevronRightIcon />
                      </Button>
                    </Box>
                  )}
                </Box>
              </>
            ) : (
              <Box mt="4">
                <Text fontWeight="bold">Your CryptoUkiyoe collection is not found.</Text>
                <Box mt="8">
                  <a
                    href="https://opensea.io/collection/cryptoukiyoe"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button colorScheme="teal" variant="outline" minW={{ base: 'full', md: '60' }}>
                      <Search2Icon />
                      <chakra.span ml="2">Search on OpenSea</chakra.span>
                    </Button>
                  </a>
                </Box>
              </Box>
            )}
          </>
        )}
      </chakra.section>
    </>
  )
}
